/**
 * Lazy Loading Module
 * Implements lazy loading functionality for DFP Ads
 * version 2.0.1
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdModules/targeting',[
    "jquery",
    "logging",
    "utilities"
], function( $, logging, utilities ) {
    "use strict";

    var _ModuleName = "Targeting Module";

    var _config = { 
        targetmapping: { }
    };
    var _data = {
        pageconfig: { },
        targets: { }
    }

    var init = function(config) {
        $.extend(_config, config.targeting);
        $.extend(_config.targetmapping, config.targetmapping);
    }

    var start = function(pageconfig) {
        _data.pageconfig = pageconfig;
    }

    var loadTargeting = function( monitor ) {
        ;

        utilities.subscribeToReadyMonitor(monitor, "targeting");

        for(var mapkey in _config.targetmapping) {
            ;

            var map = _config.targetmapping[mapkey];

            // Key: Value, assumes same key is used on pageconfig where data is to be pulled, and DFP
            if(typeof map == 'string') {
                var value = _data.pageconfig[mapkey];
                ;
                _setTarget(mapkey, value);
            }

            // Key: Function, runs function to calculate value and assumes same key is used on DFP
            else if(typeof map == 'function') {
                var value = map[mapkey](_data.pageconfig);
                ;
                _setTarget(mapkey, key);
            }

            // Key: Object
            else if(typeof map == 'object') {
                ;
                // Calculate Key to use
                var key = (map.key && typeof map.key == 'string') ? map.key : mapkey;

                
                if(typeof map.conditional == "object") {
                    // Process Conditional
                    _processConditional(map, key, monitor);
                } else {
                    _getValueAndSetTarget(map, key, monitor);
                }
            } else {
                logging.warn("Something went wrong trying to process target " + mapkey, _ModuleName);
            }
        }

        utilities.confirmReady(monitor, 'targeting');
    }

    /**
     * Gets the value and sets the target
     * @param {Object} map target mapping we're working with
     * @param {String} key target key used in key:value pair
     * @param {String} monitor Name of ready monitor we'll be subscribing to if we have to do things async
     */
    var _getValueAndSetTarget = function(map, key, monitor) {
        // Value is of type String
        if(typeof map.value == 'string') {
            ;
            _setTarget(key, map.value);
        }

        // Value is of type Function
        else if(typeof map.value == 'function') {
            var value = map.value(_data.pageconfig);
            ;
            _setTarget(key, value)
        }

        // Value is of type Object
        else if(typeof map.value == 'object') {
            ;
            if(Array.isArray(map.value.requirements) && map.value.requirements.length) {
                ;
                _calculateResponseAsync(map.value, "targeting-value-" + key, monitor, function( response ) {
                    ;
                    _setTarget(key, response);
                });
            } else {
                ;
                 _calculateResponse(map.value, function( response ) {
                    ;
                    _setTarget(key, response);
                 });
            }
        }

        else {
            logging.warn("Something went wrong calculateing the value for " + key, _ModuleName);
        }
    }

    /**
     * Handles the object configuration for calculating some value, but does so async as it needs to load some require modules
     * @param {Object} config configuration for response to calculate
     * @param {String} name Ready monitor process name to use, must be unique
     * @param {String} monitor name of ready monitor to subscribe to
     * @param {Function} callback Function to call once response is calculated
     */
    var _calculateResponseAsync = function( config, name, monitor, callback ) {
        if(Array.isArray(config.requirements) && config.requirements.length) {

            utilities.subscribeToReadyMonitor(monitor, name);

            require(config.requirements, function() {
                var modules = $.makeArray(arguments); // Get List of Modules Loaded
                // If page config should be included, add it
                if(config.pageconfig) {
                    modules.push(_data.pageconfig);
                }
                if(typeof config.calculate == 'boolean' || typeof config.calculate == 'string') {
                    if(typeof callback == 'function') {
                        callback(config.calculate);
                    }
                }
                // Run calculation function
                if(typeof config.calculate == 'function') {
                    var response = config.calculate.apply(this, modules);
                    // Call the callback function if provided
                    if(typeof callback == 'function') {
                        callback(response);
                    }
                }
                utilities.confirmReady(monitor, name);
            })
        }
    }

    /**
     * Handles the object configuration for calculating some value
     * @param {Object} config configuration for response to calculate
     * @param {Function} callback Function to call once response is calculated
     */
    var _calculateResponse = function( config, callback ) {
        if(!Array.isArray(config.requirements) || config.requirements.length == 0) {
            var modules = [];
            // If page config should be included, add it
            if(config.pageconfig) {
                modules.push(_data.pageconfig);
            }

            if(typeof config.calculate == 'boolean' || typeof config.calculate == 'string') {
                if(typeof callback == 'function') {
                    callback(config.calculate);
                }
            }
            // Run calculation function
            if(typeof config.calculate == 'function') {
                var response = config.calculate.apply(this, modules);
                // Call the callback function if provided
                if(typeof callback == 'function') {
                    callback(response);
                }
            }
        } else {
            logging.error("Requirements are defined. Response should be calculated async", _ModuleName);
        }
    }

    /**
     * Set the DFP Target
     * @param {String} key Targeting Key
     * @param {String} value Targeting Value
     */
    var _setTarget = function(key, value) {
        window.googletag.pubads().setTargeting(key, (value || ""));
        _data.targets[key] = (value || "");
    }

    /**
     * Handles the conditional to decide whether or not to calculate the value
     * @param {Object} map target mapping we're working with
     * @param {String} key target key used in key:value pair
     * @param {String} monitor Name of ready monitor we'll be subscribing to if we have to do things async
     */
    var _processConditional = function(map, key, monitor) {
        // Check and Handle Conditional
        if(Array.isArray(map.conditional.requirements) && map.conditional.requirements.length) {
            ;
            _calculateResponseAsync(map.conditional, "targeting-conditional-" + key, monitor, function( response ) {
                if(typeof response == 'boolean' && response) {
                    ;
                    _getValueAndSetTarget(map, key, monitor);
                } else {
                    ;
                }
            });
        } else {
            ;
             _calculateResponse(map.conditional, function( response ) {
                if(typeof response == 'boolean' && response) {
                    ;
                    _getValueAndSetTarget(map, key, monitor);
                } else {
                    ;
                }
             });
        }
    }

    /**
     * Prints targeting data to the console for debugging purposes
     */
    var printTargetDataToConsole = function() {
        console.log("DFP Targeting: %o", _data.targets);
    }

    return {
        init: init,
        start: start,
        loadTargeting: loadTargeting,
        printTargetDataToConsole: printTargetDataToConsole
    }
});
